const observer: {
  handlers: WeakMap<Element, () => void>
  instance: IntersectionObserver | null
} = {
  handlers: new WeakMap(),
  instance: new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        const element = entry.target

        const observerHandler = observer.handlers.get(element)

        observer.instance?.unobserve(element)
        observer.handlers.delete(element)

        if (!observerHandler) {
          return
        }

        observerHandler()
      })
    },
    {
      rootMargin: '100px 0px 100px 0px',
    }
  ),
}

export const visibleObserver = {
  observe(element: Element, callback: () => void) {
    observer.handlers.set(element, callback)
    observer.instance?.observe(element)
  },
  unobserve(element: Element) {
    observer.handlers.delete(element)
    observer.instance?.unobserve(element)
  },
}
